import React from 'react';
import _ from 'lodash';
import { Button, Checkbox, Divider, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { useMutation, useParameterizedQuery } from 'react-fetching-library';
import { useApplication } from '../../../ApplicationsContext';
import { updateAdditionalDocumentAction, downloadStaffAdditionalDocumentAction, deleteAdditionalDocumentAction } from '../../../../../../services/request';
import toast from 'react-hot-toast';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DocumentForm from './additional-documents/DocumentForm';
import { ConfirmDialog } from '../../../../../../components/ConfirmDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import PDFPreviewModal from './PDFPreviewModal';

export const AdditionalDocuments = () => {
  const { rowData, setRowData } = useApplication();
  const { mutate } = useMutation(updateAdditionalDocumentAction);
  const { query } = useParameterizedQuery(downloadStaffAdditionalDocumentAction);
  const { mutate: deleteMutate } = useMutation(deleteAdditionalDocumentAction);
  const [openAddDocument, setOpenAddDocument] = React.useState(false);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = React.useState(false);
  const [deleteData, setDeleteData] = React.useState({});
  const [previewUrl, setPreviewUrl] = React.useState(null);

  const handleClick = async (id, confirmed_by_office) => {
    const { payload, error, loading } = await mutate({ confirmed_by_office: !confirmed_by_office }, id);
    if (!error && !loading) {
      setRowData(prev => ({ ...prev, staff_documents_added_by_staff: prev.staff_documents_added_by_staff.map(sd => sd.id == payload.id ? payload : sd) }));
      if (confirmed_by_office) {
        toast.success('Odznaczono zapoznanie z dokumentem');
      } else {
        toast.success('Oznaczono zapoznanie z dokumentem');
      }
    }
  };

  const handleDownload = async (row, preview = false) => {
    const { payload, error, loading } = await query(row.id);

    if (!error) {
      if (preview) {
        setPreviewUrl(window.URL.createObjectURL(payload));
      } else {
        const url = window.URL.createObjectURL(payload);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = `${row.file_name}`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } else {
      toast.error('Nie udało się pobrać szablonu');
    }
  };

  const handleAddDocument = newDoc => {
    setRowData(prev => ({ ...prev, staff_documents_added_by_office: [...prev.staff_documents_added_by_office, newDoc] }));
  };

  const handleOpenDeleteModal = rowData => {
    setDeleteData(rowData);
    setConfirmDeleteOpen(true);
  };

  const handleDelete = async id => {
    const { error } = await deleteMutate(id);
    if (!error) {
      setRowData(prev => ({
        ...prev,
        staff_documents_added_by_office: prev.staff_documents_added_by_office.filter(element => element.id !== id),
        staff_documents_added_by_staff: prev.staff_documents_added_by_staff.filter(element => element.id !== id)

      }));
      toast.success('Załącznik został usunięty');
    }

    if (error) {
      toast.error('Nie udało się usunąć załącznika');
    }
  };

  const Component = ({ addedByStaff }) => (
    <Stack direction="column" justifyContent="center" alignItems="left" >
      { addedByStaff ? <Typography color="green" sx={{ p: 1 }}>
        Dokumenty dodatkowe (dodane przez pracownika)
      </Typography>
        : <Stack direction="row" mb={1}>
          <Typography color="green" sx={{ p: 1 }}>Dokumenty dodatkowe (dodane przez biuro)</Typography>
          <Button variant="contained" size="small" onClick={() => setOpenAddDocument(true)}>
              Dodaj Plik
          </Button>
        </Stack>
      }
      {addedByStaff && _.map(rowData.staff_documents_added_by_staff, (item, key) => (
        <div key={key}>
          <Divider flexItem />
          <Stack
            direction="row"
            key={key}
            alignItems="center"
            justifyContent="center"
          >
            <Stack flex="1 1 80%" direction="row" alignItems="center">
              <Tooltip title={item.description}>
                <Typography variant="caption"><b>{item.name}</b></Typography>
              </Tooltip>
            </Stack>
            <Divider orientation="vertical" flexItem sx={{ ml: 1, mr: 1 }} />
            <Stack direction="row" flex="1 1 20%">
              <Stack direction="row" alignItems="center" key={key}>
                <Typography variant="caption">Oznacz zapoznanie z dokumentem</Typography>
                <Checkbox
                  disabled={false}
                  checked={item.confirmed_by_office}
                  onClick={() => handleClick(item.id, item.confirmed_by_office)}
                />

              </Stack>
              <Divider orientation="vertical" flexItem sx={{ ml: 1, mr: 1 }} />
              <Stack direction="row" spacing={0.5}>
                {item.can_preview && <Tooltip title="Pokaż">
                  <IconButton onClick={() => handleDownload(item, true)}>
                    <RemoveRedEyeIcon color="primary" />
                  </IconButton>
                </Tooltip>}
                <Tooltip title="Pobierz Plik" onClick={() => handleDownload(item)}>
                  <IconButton color="info">
                    <FileDownloadIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Usuń" onClick={() => handleOpenDeleteModal(item)}>
                  <IconButton
                    color="error"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </Stack>
            </Stack>
          </Stack>
        </div>
      ))}
      {!addedByStaff && _.map(rowData.staff_documents_added_by_office, (item, key) => (
        <div key={key}>
          <Divider flexItem />
          <Stack
            direction="row"
            key={key}
            alignItems="center"
            justifyContent="center"
          >
            <Stack flex="1 1 80%" direction="row" alignItems="center">
              <Tooltip title={item.description}>
                <Typography variant="caption"><b>{item.name}</b></Typography>
              </Tooltip>
            </Stack>
            <Divider orientation="vertical" flexItem sx={{ ml: 1, mr: 1 }} />
            <Stack direction="row" flex="1 1 20%">
              <Stack direction="row" alignItems="center" key={key}>
                <Typography variant="caption">Zapoznano</Typography>
                <Checkbox
                  disabled={true}
                  checked={item.confirmed_by_staff}
                />
              </Stack>
              <Divider orientation="vertical" flexItem sx={{ ml: 1, mr: 1 }} />
              <Stack direction="row" spacing={0.5}>
                {item.can_preview && <Tooltip title="Pokaż">
                  <IconButton onClick={() => handleDownload(item, true)}>
                    <RemoveRedEyeIcon color="primary" />
                  </IconButton>
                </Tooltip>}
                <Tooltip title="Pobierz Plik" onClick={() => handleDownload(item)}>
                  <IconButton color="info">
                    <FileDownloadIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Usuń" onClick={() => handleOpenDeleteModal(item)}>
                  <IconButton
                    color="error"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </Stack>
            </Stack>
          </Stack>
        </div>
      ))}
    </Stack>
  );

  return (
    <Stack direction="column" mb={2}>
      <Component addedByStaff={true} />
      <Component addedByStaff={false} />
      <Divider flexItem />
      <DocumentForm
        open={openAddDocument}
        handleClose={() => setOpenAddDocument(false)}
        handleAddDocument={handleAddDocument}
        applicationId={rowData.id} />
      <ConfirmDialog
        open={confirmDeleteOpen}
        setOpen={setConfirmDeleteOpen}
        onConfirm={() => handleDelete(deleteData.id)}
      >
        <p>Czy na pewno chcesz usunąć <b>{deleteData.file_name}</b>?</p>
      </ConfirmDialog>
      {previewUrl !== null ? <PDFPreviewModal url={previewUrl} handleClose={() => setPreviewUrl(null)}/> : null}
    </Stack>
  );
};
